import * as yup from 'yup';

import { BooleanTypeBase } from '../../baseTypes/BooleanTypeBase';
import { AllTypeContexts } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_OTHER } from '../constants';

export class BooleanType extends BooleanTypeBase {
  group = TYPE_GROUP_OTHER;
  contexts = AllTypeContexts;
  name = 'Boolean';
  friendlyName = 'Yes / No';

  get example() {
    return true;
  }

  get default(): any {
    return false;
  }

  formatter = (value: any) => (value ? 'Yes' : 'No');

  buildSchema() {
    return yup.boolean().nullable();
  }
}

const definition = new BooleanType();

Types.addBaseType(definition);

export { definition as BooleanDefinition };
